/**
 *火花产品
 *@author xujinjiang
 *@date 2022/3/29 16:49
 */
export const HuohuaProducts = [
  {
    icon: require('@/assets/img-web/huohua-ppt@2x.png'),
    title: '火花 PPT 插件',
    showDescription: false,
    desc: {
      title: '火花 PPT 插件',
      subtitle: '在备课和授课环节，PPT 是许多老师的首选工具，将火花素材直接添加到课件中，更加快速便捷。'
    }
  },
  {
    icon: require('@/assets/img-web/huohua-app@2x.png'),
    title: '火花客户端',
    showDescription: false,
    desc: {
      title: '火花客户端',
      subtitle: '我们提供了帮助老师管理火花资源的备课管理模块，让老师轻松管理火花资源和自己的课件资源。'
    }
  },
  {
    icon: require('@/assets/img-web/school-portal@2x.png'),
    title: '校本门户',
    showDescription: false,
    desc: {
      title: '校本门户',
      subtitle: '提供火花校本门户网站，网站包含已购买的火花产品，数据看板和帮助中心。'
    }
  }
];
